/**
 * Static top-10 lookup for leveraged-2x underlyings.
 * Keyed by the underlying ETF ticker (e.g. "CQTM").
 */
export interface Top10HoldingsEntry {
  ticker?: string;
  name: string;
  weightPct: number | null;
  cusip?: string;
}

export interface Top10HoldingsPayload {
  asOf?: string;
  entries: Top10HoldingsEntry[];
}

const REGISTRY: Record<string, Top10HoldingsPayload> = {
  CQTM: {
    asOf: "2026-02-23",
    entries: [
      { ticker: "IONQ", name: "IonQ Inc.", weightPct: 12.5 },
      { ticker: "RGTI", name: "Rigetti Computing Inc.", weightPct: 9.8 },
      { ticker: "QBTS", name: "D-Wave Quantum Inc.", weightPct: 8.2 },
      { ticker: "IBM", name: "IBM Corp.", weightPct: 7.1 },
      { ticker: "GOOG", name: "Alphabet Inc.", weightPct: 6.5 },
      { ticker: "HON", name: "Honeywell Intl Inc.", weightPct: 5.2 },
      { ticker: "MSFT", name: "Microsoft Corp.", weightPct: 4.8 },
      { ticker: "NVDA", name: "Nvidia Corp.", weightPct: 4.2 },
      { ticker: "QUBT", name: "Quantum Computing Inc.", weightPct: 3.6 },
      { ticker: "ARQQ", name: "Arqit Quantum Inc.", weightPct: 3.1 },
    ],
  },
};

export function getLeveragedTop10(underlyingTicker?: string): Top10HoldingsPayload | undefined {
  return underlyingTicker ? REGISTRY[underlyingTicker] : undefined;
}
